export default {
  pc_infor: {
    marginTop: '0',
    marginRight: '80%',
    marginBottom: '0',
    marginLeft: '0'
  },
  pc_widgets_infor: {
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_vip_header/style.js